import { AppState } from "@/store/appState/state";

import { getStoreAccessors } from "typesafe-vuex";
import { State as RootState } from "@/store/state";

export const getters = {
  getError: (state: AppState) => state.error,
  getErrorTimeout: (state: AppState) => state.errorTimeout,
  getHasUnsavedChanges: (state: AppState) => state.hasUnsavedChanges
};

const { read } = getStoreAccessors<AppState, RootState>("");

export const readError = read(getters.getError);
export const readErrorTimeout = read(getters.getErrorTimeout);
export const readHasUnsavedChanges = read(getters.getHasUnsavedChanges);
